
	// HugeRTE version of your TinyMCE-based HtmlEditor
	import { defineComponent } from "vue";
	import Editor from "@hugerte/hugerte-vue";

	export default defineComponent({
		name: "html-editor",
		components: { Editor },
		emits: ["onChange"],
		props: {
			source: { type: String, required: true },
			isPdf: { type: Boolean, required: false, default: false },
			plugins: { type: String, required: false },
			height: { type: Number, required: false },
			width: { type: Number, required: false },
			toolbar: { type: String, required: false },
			disabled: { type: Boolean, required: false, default: false },
		},
		created() {
			this.text = this.source;
		},
		data() {
			return {
				text: "",

				// HugeRTE Vue wrapper will load from jsDelivr by default if you don't specify,
				// but being explicit can help avoid surprises.
				// Docs show jsDelivr usage for HugeRTE. :contentReference[oaicite:2]{index=2}
				hugerteScriptSrc: "https://cdn.jsdelivr.net/npm/hugerte@1/hugerte.min.js",
			};
		},
		methods: {
			onModelUpdate(value: string) {
				this.text = value;
				this.$emit("onChange", this.text);
			},
		},
		computed: {
			fonts(): string {
				return this.isPdf
					? "Courier=courier; Helvetica=helvetica; Times New Roman=times new roman,times"
					: "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva";
			},
			options(): object {
				return {
					height: this.height ?? 500,
					width: this.width ?? "100%",
					menubar: "file edit view insert format tools table help",
					toolbar:
						this.toolbar ??
						[
							"undo redo | blocks | fontfamily fontsize | forecolor backcolor",
							"bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | lineheight | numlist bullist | image link table | removeformat",
						],
					plugins: this.plugins ?? "lists advlist link table image",
					content_style:
						"body { font-family: Helvetica; font-size: 12pt } p, h1, h2, h3, h4, h5, h6 { margin: 0 }",
					font_family_formats: this.fonts,

					table_cell_class_list: [
						{ title: "None", value: "" },
						{ title: "No Borders", value: "no-borders" },
						{ title: "No Left Border", value: "no-left-border" },
						{ title: "No Right Border", value: "no-right-border" },
						{ title: "No Top Border", value: "no-top-border" },
						{ title: "No Bottom Border", value: "no-bottom-border" },
						{ title: "No Side Borders", value: "no-x-borders" },
						{ title: "No Top/Bottom Border", value: "no-y-borders" },
					],

					// Same pattern you had in TinyMCE
					// eslint-disable-next-line no-unused-vars
					file_picker_callback: (cb: any, _value: any, _meta: any) => {
						const input = document.createElement("input");
						input.setAttribute("type", "file");

						input.onchange = () => {
							if (!input.files || input.files.length < 1) return;

							const file = input.files[0];
							const reader = new FileReader();

							reader.onload = () => {
								const imageUrl = reader.result;
								const blobInfo = { blobUri: imageUrl };
								cb(imageUrl, blobInfo);
							};

							reader.readAsDataURL(file);
						};

						input.click();
					},
				};
			},
		},
		watch: {
			source() {
				this.text = this.source;
			},
		},
	});
